export default "__VITE_ASSET__CsgqmkNe__"